import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Prompt } from 'src/api'
import { APIList } from 'src/interfaces'
import { useApiInstance } from './useApiInstance'
import { buildRequestParams, ObjectType, transformPage, transformPerPage } from './helpers'

interface RequestParams {
  params?: Partial<AdminPromptsGetParams>;
  paramsTransform?: Array<(params: Record<string, any>) => Record<string, any>>;
  options?: Omit<UseQueryOptions<unknown, Error, APIList<Prompt>>, 'queryKey' | 'queryFn'>;
}

export interface AdminPromptsGetParams {
  limit: number;
  offset: number;
  sort: string;
}

const schema: ObjectType['schema'] = {
  limit: 'number',
  offset: 'number',
  sort: 'string'
}

export const usePromptListRequest = ({ params = {}, paramsTransform = [], options }: RequestParams = {}) => {
  const api = useApiInstance()

  const transformedParams = [transformPerPage, transformPage, ...paramsTransform].reduce(
    (param, transform) => transform(param),
    params
  )

  const queryParams = buildRequestParams<AdminPromptsGetParams>(transformedParams, schema)

  return useQuery<unknown, Error, APIList<Prompt>>(
    [Entities.Prompts, JSON.stringify(transformedParams)],
    async () => {
      const { limit, offset, sort } = queryParams
      const { data } = await api.v1AdminPromptsGet(limit, offset, sort)
      return data
    },
    { ...options }
  )
}
